import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/what-is-oopbuy-spreadsheet", element: <ArticlePage /> },
  { path: "/oopbuy-vs-manual-tracking", element: <ArticlePage /> },
  { path: "/best-oopbuy-spreadsheet-template", element: <ArticlePage /> },
  { path: "/oopbuy-spreadsheet-beginner-guide", element: <ArticlePage /> },
  { path: "/how-to-use-oopbuy-spreadsheet", element: <ArticlePage /> },
  { path: "/oopbuy-vs-google-sheets", element: <ArticlePage /> },
  { path: "/oopbuy-vs-airtable", element: <ArticlePage /> },
  { path: "/how-to-track-suppliers-efficiently", element: <ArticlePage /> },
  { path: "/how-to-calculate-profit-in-spreadsheet", element: <ArticlePage /> },
  { path: "/common-mistakes-in-product-tracking", element: <ArticlePage /> },
  { path: "/advanced-oopbuy-tracking-system", element: <ArticlePage /> },
  { path: "/automated-product-spreadsheet", element: <ArticlePage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;